import {
  GET_INVOICES_BY_TEMPLATE_LOADING,
  GET_INVOICES_BY_TEMPLATE_SUCCESS,
  GET_INVOICES_BY_TEMPLATE_FAILED,
  GET_INVOICES_BY_TEMPLATE_RESET,
} from "../types";

const initialState = {
  loading: false,
  invoices: [],
  error: null,
  totalRecords: 0,
  currentPage: 0,
  totalPages: 0,
};

const getInvoicesByTemplateReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_INVOICES_BY_TEMPLATE_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_INVOICES_BY_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: action.payload.content || action.payload.data || [],
        totalRecords: action.payload.totalElements || action.payload.totalRecords || 0,
        currentPage: action.payload.pageable?.pageNumber || action.payload.currentPage || 0,
        totalPages: action.payload.totalPages || 0,
        error: null,
      };
    case GET_INVOICES_BY_TEMPLATE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
        invoices: [],
      };
    case GET_INVOICES_BY_TEMPLATE_RESET:
      return initialState;
    default:
      return state;
  }
};

export default getInvoicesByTemplateReducer;